import { jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { useFormCom, useFormEvent } from "./utils.js";
const getInputData = (input)=>'object' == typeof input && null !== input ? JSON.stringify(input) : input;
const FormContainer = ({ children, value, onChange })=>{
    const Form = useFormCom();
    const [form] = Form.useForm();
    const { focusField, ...formIns } = form;
    const { emit } = useFormEvent();
    useEffect(()=>{
        try {
            const { input } = form.getFieldsValue();
            if (getInputData(input) !== getInputData(value)) form.setFieldValue('input', value);
        } catch  {}
    }, [
        form,
        value
    ]);
    return /*#__PURE__*/ jsx(Form, {
        form: {
            ...formIns,
            focusField: focusField ?? (()=>{})
        },
        component: false,
        onValuesChange: ({ input })=>onChange?.(input, emit),
        children: /*#__PURE__*/ jsx(Form.Item, {
            name: "input",
            children: children
        })
    });
};
const src_FormContainer = FormContainer;
export { src_FormContainer as default };
